import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'user-menu',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    button: {
      // color: theme.palette.grey[400],
      '& > svg': {
        marginLeft: theme.spacing(0.5),
        color: (props: any) => (props.variant === 'light' ? 'white' : theme.palette.primary.main),
      },
    },
    avatar: {
      borderRadius: 16,
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.common.white,
      marginRight: theme.spacing(1),
      width: theme.spacing(4),
      height: theme.spacing(4),
      overflow: 'hidden',
      '& svg': {
        display: 'block',
        margin: theme.spacing(0.5),
      },
      '& img': {
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    dropdown: {
      boxShadow: 'none',
    },
    dropdownItem: {},
  }),
  options
);

export default useStyles;
